const SAVE_PAYMENTS = 'home/SAVE_PAYMENTS';
const SAVE_QUERIES = 'home/SAVE_QUERIES';
const SAVE_USERS = 'home/SAVE_USERS';

export { SAVE_PAYMENTS, SAVE_QUERIES, SAVE_USERS };
